const sprite = RAILS_ASSET_URL('/sprites/snowflakes.svg')

const supported = typeof Element.prototype.animate == 'function'
&& CSS.supports('translate', '1px 1px 0px')
&& CSS.supports('scale', '1.5')
&& CSS.supports('inset', '0 0 0 0')

let container

const createFlake = (x, color, element) => {
  const phase = Math.random() * 360
  const radius = Math.random() * 1
  const speed = 1 + Math.random() * 2
  const scale = Math.random()
  const left = x + Math.random() * x

  if (!container) {
    container = document.createElement('div')
    container.style.pointerEvents = 'none'
    container.style.position = 'absolute'
    container.style.inset = '0 0 0 0'
    container.style.overflow = 'hidden'
    container.style.zIndex = -1
    element.appendChild(container)
  }

  const flake = document.createElement('div')
  flake.style.position = 'absolute'
  flake.style.top = 0
  flake.style.left = left + 'px'
  flake.style.fill = color
  flake.style.scale = scale
  flake.style.opacity = 1
  flake.style.translate = '0px -150px 0px'
  flake.style.transition = [
    `translate ${(innerHeight + 200) / (speed * 60)}s linear`,
    `opacity ${innerHeight / 60}s`,
  ].join()

  flake.innerHTML = `<svg><use href="${sprite}#flake1" /></svg>`
  container.appendChild(flake)

  flake.addEventListener('transitionend', e => {
    if (e.propertyName == 'translate')
      container.removeChild(flake)
  })

  flake.offsetHeight // force draw
  flake.style.translate = `0px ${innerHeight + 50}px 0px`
  flake.style.opacity = 0

  flake.animate?.([
    { transform: `translateX(-${radius * 30}px) rotate(${radius * 15}deg)` },
    { transform: `translateX(${radius * 30}px) rotate(-${radius * 15}deg)` },
  ], {
    duration: 1000,
    iterations: Infinity,
    delay: phase,
    direction: 'alternate',
    easing: 'ease-in-out',
  })
}

const show = ({ density, color, element }) => {
  if (!supported) return
  density = density / 300
  const count = innerWidth * density
  for (let i = 0; i < count; i++) {
    createFlake(i / density, color, element)
  }
}

const element = document.querySelector('.home-snow')
let interval

const wave = () => show({ density: 0.5, color: '#ddf5f6', element })
const startSnow = () => interval = setInterval(wave, 1000)
const stopSnow = () => clearInterval(interval)

const handleIntersection = entries =>
  entries.forEach(entry => entry.isIntersecting ? startSnow() : stopSnow())

const init = () => {
  const observer = new IntersectionObserver(handleIntersection)
  observer.observe(element)
}

document.addEventListener('DOMContentLoaded', init)
